import { NewDownloadIcon } from "../../../assets/images";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export type AppProps = {
  title: string;
  showDownloadLedgerPdf?: boolean;
  handleLedgerStatementDownloadModal?: () => void;
  handleSetLedgerType?: (type: string) => void;
};

export const CapsHeader = ({
  title,
  showDownloadLedgerPdf,
  handleLedgerStatementDownloadModal,
  handleSetLedgerType,
}: AppProps) => {
  const handleCapsHederData = (type: string) => {
    handleLedgerStatementDownloadModal?.();
    handleSetLedgerType?.(type);
  };

  return (
    <div
      style={{
        backgroundColor: "#dd4433",
        padding: "6px 8px",
        color: "#fff",
        fontSize: "16px",
        marginTop: "10px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <strong>{title}</strong>
      {showDownloadLedgerPdf && (
        <OverlayTrigger
          placement="top"
          delay={{ show: 250, hide: 250 }}
          overlay={
            <Tooltip id="button-view">Download Ledger Statement</Tooltip>
          }
        >
          <img
            src={NewDownloadIcon}
            alt=""
            style={{ marginRight: "10px", cursor: "pointer", width: "30px" }}
            onClick={() => handleCapsHederData(title?.toLocaleLowerCase())}
          />
        </OverlayTrigger>
      )}
    </div>
  );
};
